import {call, put} from 'redux-saga/effects';
import {receiveShippingAdvisoryData} from "../actions/shippingAdvisoryActions";
import {fetchShippingAdvisoryData} from "../api/fetchShippingAdvisoryData";

export default function* getShippingAdvisoryData(action) {
  try {
    const shippingAdvisoryData = yield call(fetchShippingAdvisoryData);
    yield put(receiveShippingAdvisoryData(shippingAdvisoryData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/shippingAdvisorySaga.js